import { createClient } from "@supabase/supabase-js";
import type { Project, Task } from "./types";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = hasSupabaseConfig
  ? createClient<Database>(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export interface Database {
  public: {
    Tables: {
      tasks: {
        Row: Task;
        Insert: Omit<Task, "created_at" | "updated_at"> & Partial<Pick<Task, "created_at" | "updated_at">>;
        Update: Partial<Task>;
        Relationships: [];
      };
      projects: {
        Row: Project;
        Insert: Omit<Project, "created_at" | "updated_at"> & Partial<Pick<Project, "created_at" | "updated_at">>;
        Update: Partial<Project>;
        Relationships: [];
      };
    };
  };
}
